import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityOutputqueue } from "../../entity/EntityOutputqueue";

export class DtoOutputqueuesGetRes extends EntityOutputqueue {
  public items: EntityOutputqueue[]  = [];
}
